export default __webpack_public_path__ + "static/media/datadog-icon.1a22975c.svg";